export default __webpack_public_path__ + "static/media/AM.32c4b56d.svg";